<template>
  <div class="SortSelector">
    <ResponsivePanel
      v-model="isOpen"
      class="SortSelector-responsivePanel"
      side="bottom"
      align="start"
      :sideOffset="4"
    >
      <template #trigger>
        <ChipFilter
          :selected="isOpen"
          readonly
          leftIcon="swap-horizontal"
          :rightIcon="isOpen ? 'chevron-up' : 'chevron-down'"
        >
          {{ displayLabel }}
        </ChipFilter>
      </template>

      <FilterDrawerSection :title="label" :hidden="!isMobile">
        <RadioButtons
          v-model="model"
          :options="options"
          class="SortSelector-options"
          :size="isMobile ? 'md' : 'sm'"
          :vertical="!isMobile"
          @update:model-value="isOpen = false"
        />
      </FilterDrawerSection>
    </ResponsivePanel>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { useResponsive } from '@cvo/ui/composables';
import RadioButtons from '../../atoms/RadioButtons/RadioButtons.vue';
import ChipFilter from '../../atoms/ChipFilter/ChipFilter.vue';
import FilterDrawerSection from '../../molecules/FilterDropdownPanel/FilterDrawerSection.vue';
import ResponsivePanel from '../ResponsivePanel/ResponsivePanel.vue';
import type { SortSelectorProps } from './SortSelector.model';

const props = defineProps<SortSelectorProps>();

const model = defineModel<string>();
const isOpen = ref(false);

const displayLabel = computed(() => {
  const selected = props.options.find((opt) => opt.value === model.value);
  return selected?.label ?? props.label;
});

const { isMobile } = useResponsive();

watch(isMobile, () => {
  isOpen.value = false;
});
</script>

<style lang="scss">
@use '@cvo/ui/styles/design-system' as vars;
@use '@cvo/ui/styles/utils/text' as text;
@use '@cvo/ui/styles/utils/mixins';
@use '@cvo/ui/styles/utils/animations';

@layer cvo-ui {
  .SortSelector {
    display: inline-flex;

    &-options {
      .RadioButtons {
        gap: vars.$dimensions-d-3;
      }
    }
  }
}
</style>
